module.exports = __webpack_public_path__ + "static/affSpice.4a2e6151.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/affSpice.png
// module id = 75
// module chunks = 21571696733600 35783957827783 278999228825771